export default __webpack_public_path__ + "static/media/Wand.686fa288.png";